// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"c47f6083","997":"541912b3"}[chunkId] + ".chunk.css";
};